import { Clock } from "lucide-react";

// Bloque de diálogo por acto: qué diría Bella y qué diría Anto.
// Se añade como capa nueva bajo cada acto, sin alterar el contenido existente.
export const ActDialogue = ({ act }) => {
  if (!act?.bellaSays && !act?.antoSays) return null;
  return (
    <div className="mt-6" data-testid={`act-dialogue-${act.n}`}>
      <div className="flex items-center gap-3">
        <span className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-ink/40">
          En este acto
        </span>
        {act.duration && (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-mist px-3 py-1 font-mono text-[11px] uppercase tracking-widest text-ink/50">
            <Clock className="h-3 w-3" strokeWidth={2.4} />
            {act.duration}
          </span>
        )}
      </div>
      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        <div
          className="rounded-2xl border border-coral/25 bg-coral/5 p-4"
          data-testid={`bella-says-${act.n}`}
        >
          <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-coral">
            Bella
          </p>
          <p className="mt-1.5 text-sm italic leading-relaxed text-ink/75">
            &ldquo;{act.bellaSays}&rdquo;
          </p>
        </div>
        <div
          className="rounded-2xl border border-sky/30 bg-sky/10 p-4"
          data-testid={`anto-says-${act.n}`}
        >
          <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-sky">
            Anto
          </p>
          <p className="mt-1.5 text-sm italic leading-relaxed text-ink/75">
            &ldquo;{act.antoSays}&rdquo;
          </p>
        </div>
      </div>
    </div>
  );
};
